import http from '@/utils/http'
import convert from '@/utils/model-convert'
import {SearchArgument} from '@/models/promote-data'
import { FormArgument, FeedbackSearchArgument } from '@/models/system-department'

const ITEM_ARREARAGE_URL = '/rest/customer/report/item-charge-statistics/item-arrearage'
const YESTERDAY_EFFECT_URL = '/rest/customer/report/item-solution-page-reports/yesterday-effect'
const BALANCE_URL = '/rest/customer/report/item-consumptions/customer-balance'
const PROMOTE_DATA_URL = '/rest/customer/report/item-solution-page-reports/extend'
const CUSTOMER_ITEM = '/rest/customer/platform/items/all'
const PRODUCT_URL = '/rest/customer/platform/customer-score-good-types/allTypes'
const GOOD_URL = '/rest/customer/platform/customer-score-goods/{id}'
const ADDRESS_URL = '/rest/customer/platform/customer-addresses/getListAll'
const ADD_URL = '/rest/customer/platform/customer-addresses'
const DELETE_URL = '/rest/customer/platform/customer-addresses/{id}'
const FEEDBACK_URL = '/rest/customer/feedback/feedbacks' // 竞价数据
const FORM_LIST_URL = '/rest/customer/feedback/feedbacks/form-list' // 信息流数据
const RESOURCE_URL = '/rest/customer/feedback/resource' // 资源列表数据

export default {
  // 竞价数据
  FeedbackList ({search}, cb) {
    http.get(FEEDBACK_URL, {
      params: convert.toJson(search, FeedbackSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  // 信息流数据
  FormList ({search}, cb) {
    http.get(FORM_LIST_URL, {
      params: convert.toJson(search, FeedbackSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  // 资源列表数据
  ResourceList ({search}, cb) {
    http.get(RESOURCE_URL, {
      params: convert.toJson(search, FeedbackSearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  // 项目欠费统计
  itemArrearage (cb) {
    http.get(ITEM_ARREARAGE_URL).then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  // 昨日效果统计
  yesterdayEffect (cb) {
    http.get(YESTERDAY_EFFECT_URL).then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  // 总消费统计
  customerItem ({search}, cb) {
    http.get(CUSTOMER_ITEM, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response))
  },
  // 余额
  theBalanceTo ({search}, cb) {
    http.get(BALANCE_URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  // 推广数据
  promoteData ({search}, cb) {
    http.get(PROMOTE_DATA_URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  productMenu (cb) {
    http.get(PRODUCT_URL).then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  productGood ({id}, cb) {
    http.get(GOOD_URL.replace('{id}', id)).then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  productAddress ({id}, cb) {
    http.get(ADDRESS_URL.replace('{id}', id)).then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  createst ({form}, cb) {
    let formData = new FormData()
    formData.append('name', form.name)
    formData.append('street', form.street)
    formData.append('mobile', form.mobile)
    let add = []
    form.selected.forEach(item => {
      for (let key in item) {
        add.push({key: item[key]})
      }
    })
    formData.append('province', add[0].key)
    formData.append('city', add[1].key)
    formData.append('area', add[2].key)
    http.post(ADD_URL, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  modify ({id, form}, cb) {
    const data = convert.toJson(form, FormArgument)
    http.put(ADD_URL.replace('{id}', id), data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  delete ({id}, cb) {
    http.delete(DELETE_URL.replace('{id}', id))
      .then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/statistics.js